<template>
    <div
        class="absolute inset-0 flex items-center justify-center z-50"
        style="background: rgba(0,0,0,0.45);"
    >
        <div class="text-center" style="width: 320px; background: rgba(255,255,255,0.08); backdrop-filter: blur(8px); border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; padding: 24px 28px;">
            <p class="text-white font-semibold mb-4" style="font-size: 14px; letter-spacing: 0.02em;">Loading map data...</p>
            <div class="rounded-full overflow-hidden" style="height: 10px; background: rgba(255,255,255,0.15);">
                <div
                    class="h-full rounded-full transition-all ease-out"
                    :style="{
                        width: progress + '%',
                        background: 'linear-gradient(90deg, #16a34a, #4ade80)',
                        boxShadow: '0 0 12px rgba(74,222,128,0.8)',
                        transitionDuration: progress === 100 ? '200ms' : '300ms'
                    }"
                ></div>
            </div>
            <p class="mt-3 font-bold" style="font-size: 15px; color: #4ade80;">{{ Math.round(progress) }}%</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReatlasLoadingOverlay',

    props: {
        progress: {
            type: Number,
            default: 0
        }
    }
}
</script>
